module.exports = __webpack_public_path__ + "img/il.2d7ed5d5.svg";